import { Link, useLocation, useNavigate } from "react-router-dom";

const display = { fontFamily: "'Fraunces', serif" };

function AdminNav() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.removeItem("isAdmin");
    navigate("/admin");
  };

  const tabs = [
    { path: "/admin/dashboard", label: "Products" },
    { path: "/admin/orders", label: "Orders" },
  ];

  return (
    <div
      className="sticky top-0 z-10 backdrop-blur-md px-6 sm:px-10 py-4 flex items-center justify-between"
      style={{
        background: "rgba(253, 251, 247, 0.92)",
        borderBottom: "1px solid #E8E0D8",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      <div className="flex items-center gap-6">
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-full flex items-center justify-center"
            style={{ background: "#3E5645" }}
          >
            <span className="text-white text-sm font-bold" style={display}>M</span>
          </div>
          <div>
            <h1 className="text-[#3E5645] text-sm font-semibold leading-none" style={display}>
              The Ledger
            </h1>
            <p className="text-[#6B7A6E] text-[10px] mt-0.5">Store inventory</p>
          </div>
        </div>

        <div className="hidden sm:flex items-center gap-1 bg-[#FBF9F2] rounded-xl p-1" style={{ border: "1px solid #E8E0D8" }}>
          {tabs.map((tab) => (
            <Link
              key={tab.path}
              to={tab.path}
              className="px-4 py-1.5 rounded-lg text-xs font-semibold transition-colors"
              style={{
                background: location.pathname === tab.path ? "#3E5645" : "transparent",
                color: location.pathname === tab.path ? "#FFFFFF" : "#6B7A6E",
              }}
            >
              {tab.label}
            </Link>
          ))}
        </div>
      </div>

      <button
        onClick={handleLogout}
        className="text-[#6B7A6E] text-xs font-medium hover:text-[#3E5645] transition-colors px-3 py-1.5 rounded-lg"
        style={{ border: "1px solid #D4C8BC" }}
      >
        Lock &amp; Exit
      </button>
    </div>
  );
}

export default AdminNav;